module.exports = __webpack_public_path__ + "static/media/msLogoGreen.7d84f2da.svg";